/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".multiselect-dropdown-container[_ngcontent-%COMP%]{width:calc(100% - 5px)!important;display:inline-block}"];
export { styles as styles };
